// GS1 modulo-10 check digit (GTIN-8/12/13/14, SSCC, GLN, GRAI…): weights 3,1,3,1,…
// applied from the rightmost body digit. Used when the system issues identifiers
// under the tenant's prefix (§3.5) and to pre-check numbers before the engine.
export function gs1CheckDigit(body) {
    if (!/^\d+$/.test(body))
        throw new TypeError("check digit body must be digits");
    let sum = 0;
    let weight = 3;
    for (let i = body.length - 1; i >= 0; i--) {
        sum += Number(body[i]) * weight;
        weight = weight === 3 ? 1 : 3;
    }
    return String((10 - (sum % 10)) % 10);
}
export function withCheckDigit(body) {
    return body + gs1CheckDigit(body);
}
export function hasValidCheckDigit(key) {
    if (!/^\d{2,}$/.test(key))
        return false;
    return gs1CheckDigit(key.slice(0, -1)) === key.slice(-1);
}
/** GTIN-14 from a GS1 company prefix + item reference, with indicator digit (default 0). */
export function makeGtin14(companyPrefix, itemReference, indicator = "0") {
    const body = indicator + companyPrefix + itemReference;
    if (body.length !== 13)
        throw new RangeError(`GTIN body must be 13 digits, got ${body.length}`);
    return withCheckDigit(body);
}
/** SSCC from extension digit + company prefix + serial reference (total body 17 digits). */
export function makeSscc(extension, companyPrefix, serialReference) {
    const body = extension + companyPrefix + serialReference;
    if (body.length !== 17)
        throw new RangeError(`SSCC body must be 17 digits, got ${body.length}`);
    return withCheckDigit(body);
}
//# sourceMappingURL=checkdigit.js.map